module.exports = __webpack_public_path__ + "img/dish2.4dc38acb.png";